import { useCallback } from "react"
import { useDispatch } from "react-redux"
import validate from "validate.js";
import { createValidationStructure } from "../Helper"
import * as ActionTypes from '../NL_App/actions/actionTypes'

export const useValidation = (tabName) => {

    const dispatch = useDispatch()

    const updateError = useCallback((payload) => {
        dispatch({
            type: ActionTypes.UPDATE_VALIDATION_ERRORS,
            tabName,
            payload
        })
    }, [tabName])

    const validateError = useCallback((ids, params, validationPattern) => {
        let errors = validate(params, validationPattern) || {}
        errors = createValidationStructure(errors)
        updateError({ ...ids, ...errors })
    }, [tabName, updateError])

    return { validateError, updateError }
}